import {
  deleteEdgeSettings,
  getEdgeSettings,
  insertEdgeSettings,
} from 'components/Graph/helpers/sortSettings';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface MoveEdgeSettingsCommand {
  dragGroupIndex: number;
  dragProtocolIndex: number;
  hoverGroupIndex: number;
  hoverProtocolIndex: number;
}

export const moveEdgeSettings: GraphCommandFactory<MoveEdgeSettingsCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      const draggedEdge = getEdgeSettings(
        draft,
        command.dragGroupIndex,
        command.dragProtocolIndex,
      );
      if (!draggedEdge) {
        return;
      }
      deleteEdgeSettings(
        draft,
        command.dragGroupIndex,
        command.dragProtocolIndex,
      );
      insertEdgeSettings(
        draft,
        command.hoverGroupIndex,
        command.hoverProtocolIndex,
        draggedEdge,
      );
    });
  };
